import { useEffect, useState } from 'react';
import { Accordion, Alert, Stack } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import checkArNavParams from './check-ar-nav-params.jsx';

export default function ArNavComponent({ snippet }) {
    const { arviewenabled, arswitcherbutton, arnavigationdata } = snippet;

    const [error, setError] = useState(null);
    const [messages, setMessages] = useState(null);

    useEffect(() => {
        checkArNavParams(snippet)
            .then(setMessages)
            .catch(e => {
                if (e instanceof Error) {
                    throw e;
                }
                setError(e);
            });
    }, []);

    if (!error && !messages) {
        return 'Loading';
    }

    return (
        <Stack gap={2}
            id="ar-nav">
            {error ? (
                <Alert variant="danger">{error}</Alert>
            ) : (
                messages.map(({ message, variant }, id) => (
                    <Alert variant={variant}
                        key={id}>
                        {message}
                    </Alert>
                ))
            )}
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Raw JSON in snippet</Accordion.Header>
                    <Accordion.Body>
                        <pre>
                            {JSON.stringify(
                                {
                                    arviewenabled,
                                    arswitcherbutton,
                                    arnavigationdata
                                },
                                null,
                                2
                            )}
                        </pre>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Stack>
    );
}
ArNavComponent.propTypes = {
    snippet: PropTypes.object
};
